import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDetails from "./file-details";
import SectionLoadingProgress from "../../shared/section-loading-progress";
import { FileRecord } from "../types";
import { ClientInformation } from "../../client-config/data/types";

interface ClientFilesViewProps {
  client: ClientInformation;
  files: FileRecord[];
  onBackToList: () => void;
  onDeleteFile: (file: FileRecord) => void;
  onDownloadFile: (file: FileRecord) => void;
  onReprocessFile: (file: FileRecord) => void;
  isLoadingMore?: boolean;
  expectedFileCount?: number | null;
  loadMoreError?: unknown;
  onRetryLoading?: () => void;
}

const ClientFilesView = ({
  client,
  files,
  onBackToList,
  onDeleteFile,
  onDownloadFile,
  onReprocessFile,
  isLoadingMore = false,
  expectedFileCount = null,
  loadMoreError = undefined,
  onRetryLoading = () => {},
}: ClientFilesViewProps) => {
  return (
    <Box>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
          backgroundColor: "action.hover",
          borderRadius: 2,
          p: 2,
        }}
      >
        <Tooltip title="Back to Clients" placement="top">
          <IconButton
            onClick={onBackToList}
            size="small"
            sx={{ color: "primary.main" }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Client Files -
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {client.name}
          </Typography>
        </Box>
      </Box>

      <SectionLoadingProgress
        loadedCount={files.length}
        expectedCount={expectedFileCount}
        isLoadingMore={isLoadingMore}
        loadMoreError={loadMoreError}
        onRetry={onRetryLoading}
      />

      <FileDetails
        files={files}
        onDelete={onDeleteFile}
        onDownload={onDownloadFile}
        onReprocess={onReprocessFile}
      />
    </Box>
  );
};

export default ClientFilesView;
